import { Component, inject, Inject, OnInit, signal } from '@angular/core';
import { EFormView, EFormViewRegistry } from '../../../model/eform/eform-api.model';
import { ProcedureInstanceBase } from '../../../model/procedure-instance/procedure-instance.model';
import { Observable, of } from 'rxjs';
import { HelpLabelComponent } from '../../help-label/help-label.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { WarningMessageComponent } from '../../warning-message/warning-message.component';
import { UrlTranslationE3ToE2Response, UrlTranslationE3ToE2ResponseBase } from '../../../model/url-translation-e3-to-e2/url-translation-e3-to-e2-response.model';
import { UrlTranslationE3ToE2Service } from '../../../services/url-translation-e3-to-e2/url-translation-e3-to-e2.service';
import { SectionIndexItem } from '../../../../form-builder-viewer/models/section-index/section-index.model';
import { ConfigService } from '../../../services/config/config.service';


@Component({
    selector: 'app-e-form-view-attached',
    templateUrl: './e-form-view-attached.component.html',
    styleUrls: ['./e-form-view-attached.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        HelpLabelComponent, WarningMessageComponent
    ]
})
export class EFormViewAttachedComponent implements EFormView, OnInit {

    public configService = inject(ConfigService)

    error = signal<boolean | null>(null)
    e2FileUrl = signal<UrlTranslationE3ToE2Response | null>(null)

    constructor(urlTranslationE3ToE2Service : UrlTranslationE3ToE2Service,
        @Inject("CONTAINER_DATA") public data: { registry: EFormViewRegistry, procedureInstance: ProcedureInstanceBase}) {
        /*
        urlTranslationE3ToE2Service.findURLFileDetail(data.procedureInstance.id).subscribe((r) => {
            if (r) {
                this.e2FileUrl.set(UrlTranslationE3ToE2ResponseBase.from(r))
                this.error.set(false)
                this.data.registry.isAllSectionsLoaded()
                return;
            }
            this.error.set(true)
        })
        */
        
        this.data.registry.isAllSectionsLoaded()
    }

    sections(): Observable<SectionIndexItem[]> {
        return of([])
    }

    ngOnInit(): void {

    }

}
